import { FC, useState, useMemo } from 'react';
import { Tabs, TabItem } from '@new/common/ui/Tabs/Tabs';
import { useVideoCallContext } from '../../../../../contexts/VideoCallProvider';
import { ChatPanelContainer } from '../ChatPanel/ChatPanelContainer';
import { ScriptPanel } from '../ScriptPanel/ScriptPanel';
import { PhotosPanel } from '../MediaPanel/PhotosPanel';
import { ObjectivesPanel } from '../ObjectivesPanel/ObjectivesPanel';
import type { SidePanelTab } from '../../types';
import { CourseInfoPanelWrapper } from './CourseInfoPanelWrapper';

const INSTRUCTOR_TABS: TabItem<SidePanelTab>[] = [
  {
    value: 'course-info',
    label: 'Course info',
    content: <CourseInfoPanelWrapper />,
    keepMounted: true,
  },
  {
    value: 'script',
    label: 'Script',
    content: <ScriptPanel />,
    keepMounted: true,
  },
  {
    value: 'objectives',
    label: 'Objectives',
    content: <ObjectivesPanel />,
  },
  {
    value: 'photos',
    label: 'Photos',
    content: <PhotosPanel />,
  },
];

const CHAT_TAB: TabItem<SidePanelTab> = {
  value: 'chat',
  label: 'Chat',
  content: <ChatPanelContainer />,
  disableScroll: true,
};

export const SidePanel: FC = () => {
  const { isInstructor } = useVideoCallContext();

  const [activeTab, setActiveTab] = useState<SidePanelTab>(isInstructor ? 'course-info' : 'chat');

  const tabs = useMemo<TabItem<SidePanelTab>[]>(() => {
    return isInstructor ? [...INSTRUCTOR_TABS, CHAT_TAB] : [CHAT_TAB];
  }, [isInstructor]);

  const defaultTab = useMemo(() => (isInstructor ? 'course-info' : 'chat'), [isInstructor]);
  return (
    <div className="border-2 border-(--neutral-white-NW800) bg-white! p-3 rounded-xl w-full">
      <Tabs
        tabs={tabs}
        value={activeTab}
        defaultValue={defaultTab}
        onValueChange={setActiveTab}
        triggerClassName="w-auto! h-auto! p-2! text-xs! data-[state=active]:border-b-[var(--neutral-black-NB700)]! hover:border-b-[var(--neutral-black-NB700)]!"
        contentClassName="mt-0! flex-1 min-h-0"
      />
    </div>
  );
};
